import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1508e166&scoped=true&"
import script from "./index.vue?vue&type=script&lang=tsx&"
export * from "./index.vue?vue&type=script&lang=tsx&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=1508e166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1508e166",
  null
  
)

export default component.exports